import {useEffect, useState} from "react";
import {palette} from "../../../../shared/tools/image";
import "./BricksCount.scss";

export const BricksCount = ({counts, paletteId}) => {
  const [counter, setCounter] = useState([]);

  useEffect(() => {
    if (!counts) return;
    setCounter(Object.keys(counts).map((key, index) =>({id: index,count: counts[key]})));
  }, [counts]);
  return (
    <div className="counters-wrapper">
      {counter?.map((c)=>(
        <div key={c.id} className="counter-row">
          <div className="counter-number">{c.count}</div>
          <div className="counter-brick"><img src={palette[paletteId][c.id].img} alt=""/></div>
        </div>
      ))}
    </div>
  )
}
